module.exports = __webpack_public_path__ + "img/fishdom.224536af.jpg";